import { EventBus } from "../events/EventBus";
import { FlowDefinition } from "./FlowDefinition";
import { StepFlow } from "./StepFlow";

// =============================================================================
// StepDefinition: Registers a simple step class as part of a flow.
// Defines the step’s name, class, execution conditions, and exclusivity.
// =============================================================================

// Type alias for a constructor function that returns a StepFlow instance
export type StepFlowConstructor = new (eventBus: EventBus) => StepFlow;

// Type for local context getters
export type LocalGetCtx = <T>(key: string) => T | undefined;

// Default canExecute implementation
const defaultCanExecute = (_getCtx: LocalGetCtx, _getGlobalCtx: LocalGetCtx): boolean => true;

// StepDefinition class
export class StepDefinition {
  public readonly stepName: string;
  public readonly stepClass?: StepFlowConstructor;
  public readonly stepFlow?: FlowDefinition;
  public readonly canExecute: (getCtx: LocalGetCtx, getGlobalCtx: LocalGetCtx) => boolean;
  public readonly isExclusive: boolean;
  public readonly contextIsolation: boolean;
  public readonly contextKeepAlive: boolean;

  constructor(options: {
    stepName: string;
    stepClass?: StepFlowConstructor;
    stepFlow?: FlowDefinition;
    canExecute?: (getCtx: LocalGetCtx, getGlobalCtx: LocalGetCtx) => boolean;
    isExclusive?: boolean;
    contextIsolation?: boolean;
    contextKeepAlive?: boolean;
  }) {
    this.stepName = options.stepName;
    this.stepClass = options.stepClass;
    this.stepFlow = options.stepFlow;
    this.canExecute = options.canExecute ?? defaultCanExecute;
    this.isExclusive = options.isExclusive ?? false;
    this.contextIsolation = options.contextIsolation ?? false;
    this.contextKeepAlive = options.contextKeepAlive ?? false;
  }
}